import script from "./TabBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TabBar.vue?vue&type=script&setup=true&lang=js"

import "./TabBar.vue?vue&type=style&index=0&id=5aa509f8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa509f8"]])

export default __exports__